/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import './common';
import '../sub2/data';
import '../common/currency';
import '../common/time';
import '../client/status';
import '../../google/protobuf/empty';
import '../client/onboard/referrals';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

$root.addJSON({
  "squareup": {
    "nested": {
      "rewards": {
        "nested": {
          "GetMerchantBalanceRequest": {
            "fields": {
              "rewardName": {
                "type": "squareup.rewards.RewardName",
                "id": 3,
                "rule": "optional"
              },
              "usageUnitType": {
                "type": "squareup.sub2.data.UsageUnitType",
                "id": 4,
                "rule": "optional"
              },
              "unitToken": {
                "type": "string",
                "id": 1
              },
              "merchantToken": {
                "type": "string",
                "id": 2
              }
            },
            "nested": {
              "owner_token": {
                "oneof": [
                  "unitToken",
                  "merchantToken"
                ]
              }
            }
          },
          "GetMerchantBalanceResponse": {
            "fields": {
              "status": {
                "type": "squareup.rewards.GetMerchantBalanceResponse.Status",
                "id": 1,
                "rule": "optional"
              },
              "balance": {
                "type": "squareup.rewards.Balance",
                "id": 2,
                "rule": "optional"
              }
            },
            "nested": {
              "Status": {
                "values": {
                  "UNKNOWN": 0,
                  "SUCCESS": 1,
                  "NOT_FOUND": 2,
                  "INVALID_REQUEST": 3
                }
              }
            }
          },
          "GetMerchantBalancesRequest": {
            "fields": {
              "rewardName": {
                "type": "squareup.rewards.RewardName",
                "id": 3,
                "rule": "optional"
              },
              "usageUnitTypes": {
                "type": "squareup.sub2.data.UsageUnitType",
                "id": 4,
                "rule": "repeated"
              },
              "unitToken": {
                "type": "string",
                "id": 1
              },
              "merchantToken": {
                "type": "string",
                "id": 2
              }
            },
            "nested": {
              "owner_token": {
                "oneof": [
                  "unitToken",
                  "merchantToken"
                ]
              }
            }
          },
          "GetMerchantBalancesResponse": {
            "fields": {
              "status": {
                "type": "squareup.rewards.GetMerchantBalancesResponse.Status",
                "id": 1,
                "rule": "optional"
              },
              "balances": {
                "type": "squareup.rewards.Balance",
                "id": 2,
                "rule": "repeated"
              }
            },
            "nested": {
              "Status": {
                "values": {
                  "UNKNOWN": 0,
                  "SUCCESS": 1,
                  "NOT_FOUND": 2,
                  "INVALID_REQUEST": 3
                }
              }
            }
          },
          "GrantMerchantBalanceRequest": {
            "fields": {
              "rewardName": {
                "type": "squareup.rewards.RewardName",
                "id": 3,
                "rule": "optional"
              },
              "grantAmount": {
                "type": "int32",
                "id": 4,
                "rule": "optional"
              },
              "amountDetail": {
                "type": "squareup.rewards.AmountDetail",
                "id": 5,
                "rule": "optional"
              },
              "idempotenceToken": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              },
              "source": {
                "type": "squareup.rewards.BalanceChange.Source",
                "id": 7,
                "rule": "optional"
              },
              "reason": {
                "type": "squareup.rewards.BalanceChange.Reason",
                "id": 8,
                "rule": "optional"
              },
              "reasonDetail": {
                "type": "string",
                "id": 9,
                "rule": "optional"
              },
              "suppressNotification": {
                "type": "bool",
                "id": 10,
                "rule": "optional"
              },
              "expiresInDays": {
                "type": "int32",
                "id": 11,
                "rule": "optional"
              },
              "grantedBy": {
                "type": "string",
                "id": 12,
                "rule": "optional"
              },
              "approvedBy": {
                "type": "string",
                "id": 13,
                "rule": "optional"
              },
              "productTag": {
                "type": "string",
                "id": 14,
                "rule": "optional"
              },
              "campaignDetails": {
                "type": "string",
                "id": 15,
                "rule": "optional"
              },
              "unitToken": {
                "type": "string",
                "id": 1
              },
              "merchantToken": {
                "type": "string",
                "id": 2
              }
            },
            "nested": {
              "owner_token": {
                "oneof": [
                  "unitToken",
                  "merchantToken"
                ]
              }
            }
          },
          "GrantMerchantBalanceResponse": {
            "fields": {
              "status": {
                "type": "squareup.rewards.GrantMerchantBalanceResponse.Status",
                "id": 1,
                "rule": "optional"
              },
              "increase": {
                "type": "squareup.rewards.BalanceChange",
                "id": 2,
                "rule": "optional"
              }
            },
            "nested": {
              "Status": {
                "values": {
                  "UNKNOWN": 0,
                  "SUCCESS": 1,
                  "USER_NOT_ELIGIBLE": 2,
                  "INVALID_REQUEST": 3,
                  "NOT_SUPPORTED": 4
                }
              }
            }
          },
          "WebFreeProcessingBalance": {
            "fields": {
              "balance": {
                "type": "squareup.rewards.Balance",
                "id": 1,
                "rule": "optional"
              },
              "freeProcessingAdjustment": {
                "type": "squareup.rewards.FreeProcessingAdjustment",
                "id": 2,
                "rule": "repeated"
              },
              "freeProcessingIncrease": {
                "type": "squareup.rewards.BalanceChange",
                "id": 3,
                "rule": "repeated"
              }
            }
          },
          "MigrateFromWebBatchRequest": {
            "fields": {
              "balance": {
                "type": "squareup.rewards.WebFreeProcessingBalance",
                "id": 1,
                "rule": "repeated"
              }
            }
          },
          "MigrateFromWebBatchResponse": {
            "fields": {
              "status": {
                "type": "squareup.rewards.MigrateFromWebBatchResponse.Status",
                "id": 1,
                "rule": "optional"
              },
              "failedUserToken": {
                "type": "string",
                "id": 2,
                "rule": "repeated"
              }
            },
            "nested": {
              "Status": {
                "values": {
                  "UNKNOWN": 0,
                  "SUCCESS": 1,
                  "FAILURE": 2
                }
              }
            }
          },
          "GetFreeProcessingBalanceRequest": {
            "fields": {
              "unitToken": {
                "type": "string",
                "id": 1
              },
              "merchantToken": {
                "type": "string",
                "id": 2
              }
            },
            "nested": {
              "owner_token": {
                "oneof": [
                  "unitToken",
                  "merchantToken"
                ]
              }
            }
          },
          "GetFreeProcessingBalanceResponse": {
            "fields": {
              "freeProcessingBalance": {
                "type": "squareup.rewards.GetFreeProcessingBalanceResponse.FreeProcessingBalance",
                "id": 1,
                "rule": "optional"
              }
            },
            "nested": {
              "FreeProcessingBalance": {
                "fields": {
                  "id": {
                    "type": "int32",
                    "id": 1,
                    "rule": "optional"
                  },
                  "amountIssued": {
                    "type": "squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "amountRemaining": {
                    "type": "squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "paymentsAppliedTo": {
                    "type": "int32",
                    "id": 4,
                    "rule": "optional"
                  },
                  "expiresAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 5,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 6,
                    "rule": "optional"
                  },
                  "updatedAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 7,
                    "rule": "optional"
                  },
                  "status": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  }
                }
              }
            }
          },
          "GetFreeProcessingAdjustmentsRequest": {
            "fields": {
              "offset": {
                "type": "int32",
                "id": 3,
                "rule": "optional"
              },
              "limit": {
                "type": "int32",
                "id": 4,
                "rule": "optional"
              },
              "unitToken": {
                "type": "string",
                "id": 1
              },
              "merchantToken": {
                "type": "string",
                "id": 2
              }
            },
            "nested": {
              "owner_token": {
                "oneof": [
                  "unitToken",
                  "merchantToken"
                ]
              }
            }
          },
          "GetFreeProcessingAdjustmentsResponse": {
            "fields": {
              "freeProcessingAdjustment": {
                "type": "squareup.rewards.GetFreeProcessingAdjustmentsResponse.FreeProcessingAdjustment",
                "id": 1,
                "rule": "repeated"
              }
            },
            "nested": {
              "FreeProcessingAdjustment": {
                "fields": {
                  "id": {
                    "type": "int32",
                    "id": 1,
                    "rule": "optional"
                  },
                  "amount": {
                    "type": "squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 3,
                    "rule": "optional"
                  },
                  "updatedAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              }
            }
          },
          "GetFreeProcessingIncreasesRequest": {
            "fields": {
              "offset": {
                "type": "int32",
                "id": 3,
                "rule": "optional"
              },
              "limit": {
                "type": "int32",
                "id": 4,
                "rule": "optional"
              },
              "scope": {
                "type": "squareup.rewards.GetFreeProcessingIncreasesRequest.Scope",
                "id": 5,
                "rule": "optional"
              },
              "unitToken": {
                "type": "string",
                "id": 1
              },
              "merchantToken": {
                "type": "string",
                "id": 2
              }
            },
            "nested": {
              "Scope": {
                "values": {
                  "ALL": 0,
                  "GRANTS": 1,
                  "REFUNDS": 2
                }
              },
              "owner_token": {
                "oneof": [
                  "unitToken",
                  "merchantToken"
                ]
              }
            }
          },
          "GetFreeProcessingIncreasesResponse": {
            "fields": {
              "freeProcessingIncrease": {
                "type": "squareup.rewards.GetFreeProcessingIncreasesResponse.FreeProcessingIncrease",
                "id": 1,
                "rule": "repeated"
              }
            },
            "nested": {
              "FreeProcessingIncrease": {
                "fields": {
                  "id": {
                    "type": "int32",
                    "id": 1,
                    "rule": "optional"
                  },
                  "amount": {
                    "type": "squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 3,
                    "rule": "optional"
                  },
                  "reason": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "updatedAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              }
            }
          },
          "GetActiveBalancesRequest": {
            "fields": {}
          },
          "GetActiveBalancesResponse": {
            "fields": {
              "balance": {
                "type": "squareup.rewards.Balance",
                "id": 1,
                "rule": "repeated"
              }
            }
          },
          "GetActiveBalancesV2Request": {
            "fields": {
              "countryCode": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "languageCode": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "GetActiveBalancesV2Response": {
            "fields": {
              "balancesOfRewards": {
                "type": "squareup.rewards.GetActiveBalancesV2Response.BalancesOfReward",
                "id": 1,
                "rule": "repeated"
              },
              "mobileStatus": {
                "type": "squareup.client.Status",
                "id": 2,
                "rule": "optional"
              }
            },
            "nested": {
              "BalancesOfReward": {
                "fields": {
                  "rewardName": {
                    "type": "squareup.rewards.RewardName",
                    "id": 1,
                    "rule": "optional"
                  },
                  "balances": {
                    "type": "squareup.rewards.Balance",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "rewardHeading": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "rewardText": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "mobileRewardHeading": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "mobileRewardText": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              }
            }
          },
          "GetYourRewardsRequest": {
            "fields": {
              "countryCode": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "languageCode": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "GetYourRewardsResponse": {
            "fields": {
              "redeemableRewards": {
                "type": "squareup.rewards.GetYourRewardsResponse.RedeemableReward",
                "id": 1,
                "rule": "repeated"
              },
              "mobileStatus": {
                "type": "squareup.client.Status",
                "id": 2,
                "rule": "optional"
              }
            },
            "nested": {
              "RedeemableReward": {
                "fields": {
                  "rewardCodeUseId": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "rewardName": {
                    "type": "squareup.rewards.RewardName",
                    "id": 2,
                    "rule": "optional"
                  },
                  "rewardHeading": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "rewardText": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "mobileRewardHeading": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "mobileRewardText": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "rewardNameString": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  }
                }
              }
            }
          },
          "GetCurrentOffersRequest": {
            "fields": {
              "countryCode": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "languageCode": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "rewardProgram": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "GetCurrentOffersResponse": {
            "fields": {
              "selectableOffers": {
                "type": "squareup.rewards.GetCurrentOffersResponse.SelectableOffer",
                "id": 1,
                "rule": "repeated"
              },
              "mobileStatus": {
                "type": "squareup.client.Status",
                "id": 2,
                "rule": "optional"
              },
              "promotionalOffers": {
                "type": "squareup.rewards.PromotionalOffer",
                "id": 3,
                "rule": "repeated"
              }
            },
            "nested": {
              "SelectableOffer": {
                "fields": {
                  "rewardName": {
                    "type": "squareup.rewards.RewardName",
                    "id": 1,
                    "rule": "optional"
                  },
                  "rewardHeading": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "rewardText": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "mobileRewardHeading": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "mobileRewardText": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "rewardNameString": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              }
            }
          },
          "GetRedeemableOffersRequest": {
            "fields": {
              "countryCode": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "languageCode": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "rewardProgram": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "GetRedeemableOffersResponse": {
            "fields": {
              "selectableOffers": {
                "type": "squareup.rewards.SelectableOffer",
                "id": 1,
                "rule": "repeated"
              },
              "redeemableRewards": {
                "type": "squareup.rewards.RedeemableReward",
                "id": 2,
                "rule": "repeated"
              },
              "mobileStatus": {
                "type": "squareup.client.Status",
                "id": 3,
                "rule": "optional"
              },
              "promotionalOffers": {
                "type": "squareup.rewards.PromotionalOffer",
                "id": 4,
                "rule": "repeated"
              }
            }
          },
          "RedeemRewardRequest": {
            "fields": {
              "rewardCodeUseId": {
                "type": "int64",
                "id": 1,
                "rule": "optional"
              },
              "rewardName": {
                "type": "squareup.rewards.RewardName",
                "id": 2,
                "rule": "optional"
              },
              "rewardNameString": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "RedeemRewardResponse": {
            "fields": {
              "status": {
                "type": "squareup.rewards.RedeemRewardResponse.Status",
                "id": 1,
                "rule": "optional"
              },
              "redeemedReward": {
                "type": "squareup.rewards.RedeemRewardResponse.RedeemedReward",
                "id": 2,
                "rule": "optional"
              },
              "mobileStatus": {
                "type": "squareup.client.Status",
                "id": 3,
                "rule": "optional"
              }
            },
            "nested": {
              "Status": {
                "values": {
                  "UNKNOWN": 0,
                  "SUCCESS": 1,
                  "INVALID_REQUEST": 2
                }
              },
              "RedeemedReward": {
                "fields": {
                  "rewardHeading": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "rewardText": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "rewardSpecificMessage": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "mobileRewardHeading": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "mobileRewardText": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "balance": {
                    "type": "squareup.rewards.Balance",
                    "id": 6,
                    "rule": "optional"
                  },
                  "rewardNameString": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  }
                }
              }
            }
          },
          "WebhookIterableRequest": {
            "fields": {
              "merchantToken": {
                "type": "string",
                "id": 1,
                "rule": "required"
              }
            }
          },
          "WebhookCreateCampaignEnrollmentRequest": {
            "fields": {
              "merchantToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "expiresAfterSeconds": {
                "type": "int32",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "WebhookUpdateCampaignEnrollmentRequest": {
            "fields": {
              "merchantToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "expiresAfterSeconds": {
                "type": "int32",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "WebhookCreateMilestoneRequest": {
            "fields": {
              "merchantToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "milestoneType": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "DecrementBalanceRequest": {
            "fields": {
              "rewardName": {
                "type": "squareup.rewards.RewardName",
                "id": 3,
                "rule": "optional"
              },
              "decrementAmount": {
                "type": "int32",
                "id": 4,
                "rule": "optional"
              },
              "idempotenceToken": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              },
              "source": {
                "type": "squareup.rewards.BalanceChange.Source",
                "id": 6,
                "rule": "optional"
              },
              "reason": {
                "type": "squareup.rewards.BalanceChange.Reason",
                "id": 7,
                "rule": "optional"
              },
              "amountDetail": {
                "type": "squareup.rewards.AmountDetail",
                "id": 8,
                "rule": "optional"
              },
              "reasonDetail": {
                "type": "string",
                "id": 9,
                "rule": "optional"
              },
              "unitToken": {
                "type": "string",
                "id": 1
              },
              "merchantToken": {
                "type": "string",
                "id": 2
              }
            },
            "nested": {
              "owner_token": {
                "oneof": [
                  "unitToken",
                  "merchantToken"
                ]
              }
            }
          },
          "DecrementBalanceResponse": {
            "fields": {
              "status": {
                "type": "squareup.rewards.DecrementBalanceResponse.Status",
                "id": 1,
                "rule": "optional"
              },
              "decrease": {
                "type": "squareup.rewards.BalanceChange",
                "id": 2,
                "rule": "optional"
              }
            },
            "nested": {
              "Status": {
                "values": {
                  "UNKNOWN": 0,
                  "SUCCESS": 1,
                  "INVALID_REQUEST": 2
                }
              }
            }
          },
          "IncrementBalanceRequest": {
            "fields": {
              "merchantToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "rewardName": {
                "type": "squareup.rewards.RewardName",
                "id": 2,
                "rule": "optional"
              },
              "idempotenceToken": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "source": {
                "type": "squareup.rewards.BalanceChange.Source",
                "id": 4,
                "rule": "optional"
              },
              "reason": {
                "type": "squareup.rewards.BalanceChange.Reason",
                "id": 5,
                "rule": "optional"
              },
              "reasonDetail": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              },
              "amountDetail": {
                "type": "squareup.rewards.AmountDetail",
                "id": 7,
                "rule": "optional"
              }
            }
          },
          "IncrementBalanceResponse": {
            "fields": {
              "status": {
                "type": "squareup.rewards.IncrementBalanceResponse.Status",
                "id": 1,
                "rule": "optional"
              },
              "balanceChange": {
                "type": "squareup.rewards.BalanceChange",
                "id": 2,
                "rule": "optional"
              }
            },
            "nested": {
              "Status": {
                "values": {
                  "UNKNOWN": 0,
                  "SUCCESS": 1,
                  "INVALID_REQUEST": 2,
                  "NOT_FOUND": 3
                }
              }
            }
          },
          "LookupBalancesRequest": {
            "fields": {
              "unitToken": {
                "type": "string",
                "id": 1
              },
              "merchantToken": {
                "type": "string",
                "id": 2
              }
            },
            "nested": {
              "owner_token": {
                "oneof": [
                  "unitToken",
                  "merchantToken"
                ]
              }
            }
          },
          "LookupBalancesResponse": {
            "fields": {
              "balanceEntry": {
                "type": "squareup.rewards.LookupBalancesResponse.BalanceEntry",
                "id": 1,
                "rule": "repeated"
              },
              "status": {
                "type": "squareup.rewards.LookupBalancesResponse.Status",
                "id": 2,
                "rule": "optional"
              }
            },
            "nested": {
              "Status": {
                "values": {
                  "UNKNOWN": 0,
                  "SUCCESS": 1,
                  "NOT_FOUND": 2,
                  "INVALID_REQUEST": 3
                }
              },
              "BalanceEntry": {
                "fields": {
                  "balance": {
                    "type": "squareup.rewards.Balance",
                    "id": 1,
                    "rule": "optional"
                  },
                  "grantTotal": {
                    "type": "squareup.rewards.AmountDetail",
                    "id": 2,
                    "rule": "optional"
                  },
                  "paymentAdjustmentCount": {
                    "type": "int32",
                    "id": 3,
                    "rule": "optional"
                  },
                  "adjustmentTotal": {
                    "type": "squareup.rewards.AmountDetail",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              }
            }
          },
          "LookupFreeProcessingAdjustmentsRequest": {
            "fields": {
              "merchantToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "offset": {
                "type": "int32",
                "id": 2,
                "rule": "optional"
              },
              "limit": {
                "type": "int32",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "LookupFreeProcessingAdjustmentsResponse": {
            "fields": {
              "freeProcessingAdjustment": {
                "type": "squareup.rewards.FreeProcessingAdjustment",
                "id": 1,
                "rule": "repeated"
              },
              "status": {
                "type": "squareup.rewards.LookupFreeProcessingAdjustmentsResponse.Status",
                "id": 2,
                "rule": "optional"
              }
            },
            "nested": {
              "Status": {
                "values": {
                  "UNKNOWN": 0,
                  "SUCCESS": 1,
                  "NOT_FOUND": 2,
                  "INVALID_REQUEST": 3,
                  "NOT_APPLICABLE": 4
                }
              }
            }
          },
          "LookupBalanceChangesRequest": {
            "fields": {
              "merchantToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "offset": {
                "type": "int32",
                "id": 2,
                "rule": "optional"
              },
              "limit": {
                "type": "int32",
                "id": 3,
                "rule": "optional"
              },
              "scope": {
                "type": "squareup.rewards.LookupBalanceChangesRequest.Scope",
                "id": 4,
                "rule": "optional"
              }
            },
            "nested": {
              "Scope": {
                "values": {
                  "ALL_INCREASES": 0,
                  "ALL_CHANGES": 1,
                  "GRANTS": 2,
                  "REFUNDS": 3,
                  "DECREASES": 4
                }
              }
            }
          },
          "LookupBalanceChangesResponse": {
            "fields": {
              "balanceChange": {
                "type": "squareup.rewards.BalanceChange",
                "id": 1,
                "rule": "repeated"
              },
              "status": {
                "type": "squareup.rewards.LookupBalanceChangesResponse.Status",
                "id": 2,
                "rule": "optional"
              }
            },
            "nested": {
              "Status": {
                "values": {
                  "UNKNOWN": 0,
                  "SUCCESS": 1,
                  "NOT_FOUND": 2,
                  "INVALID_REQUEST": 3
                }
              }
            }
          },
          "GetGrantedBalanceDetailsRequest": {
            "fields": {
              "merchantToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "rewardName": {
                "type": "squareup.rewards.RewardName",
                "id": 2,
                "rule": "optional"
              },
              "grantedBy": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "firstGrantAt": {
                "type": "squareup.common.time.DateTime",
                "id": 4,
                "rule": "optional"
              },
              "lastGrantAt": {
                "type": "squareup.common.time.DateTime",
                "id": 5,
                "rule": "optional"
              },
              "currencyCode": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              },
              "offset": {
                "type": "int32",
                "id": 7,
                "rule": "optional"
              },
              "limit": {
                "type": "int32",
                "id": 8,
                "rule": "optional"
              }
            }
          },
          "GetGrantedBalanceDetailsResponse": {
            "fields": {
              "status": {
                "type": "squareup.rewards.GetGrantedBalanceDetailsResponse.Status",
                "id": 1,
                "rule": "optional"
              },
              "balanceDetails": {
                "type": "squareup.rewards.BalanceDetail",
                "id": 2,
                "rule": "repeated"
              },
              "offset": {
                "type": "int32",
                "id": 3,
                "rule": "optional"
              },
              "limit": {
                "type": "int32",
                "id": 4,
                "rule": "optional"
              }
            },
            "nested": {
              "Status": {
                "values": {
                  "UNKNOWN": 0,
                  "SUCCESS": 1,
                  "NOT_FOUND": 2,
                  "INVALID_REQUEST": 3
                }
              }
            }
          },
          "GetFinanceProductsRequest": {
            "fields": {
              "tag": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "name": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "offset": {
                "type": "int32",
                "id": 3,
                "rule": "optional"
              },
              "limit": {
                "type": "int32",
                "id": 4,
                "rule": "optional"
              }
            }
          },
          "GetFinanceProductsResponse": {
            "fields": {
              "status": {
                "type": "squareup.rewards.GetFinanceProductsResponse.Status",
                "id": 1,
                "rule": "optional"
              },
              "financeProducts": {
                "type": "squareup.rewards.FinanceProduct",
                "id": 2,
                "rule": "repeated"
              },
              "offset": {
                "type": "int32",
                "id": 3,
                "rule": "optional"
              },
              "limit": {
                "type": "int32",
                "id": 4,
                "rule": "optional"
              }
            },
            "nested": {
              "Status": {
                "values": {
                  "UNKNOWN": 0,
                  "SUCCESS": 1,
                  "NOT_FOUND": 2,
                  "INVALID_REQUEST": 3
                }
              }
            }
          },
          "GetFinanceCampaignDetailsRequest": {
            "fields": {
              "name": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "offset": {
                "type": "int32",
                "id": 2,
                "rule": "optional"
              },
              "limit": {
                "type": "int32",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "GetFinanceCampaignDetailsResponse": {
            "fields": {
              "status": {
                "type": "squareup.rewards.GetFinanceCampaignDetailsResponse.Status",
                "id": 1,
                "rule": "optional"
              },
              "financeCampaignDetails": {
                "type": "squareup.rewards.FinanceCampaignDetail",
                "id": 2,
                "rule": "repeated"
              },
              "offset": {
                "type": "int32",
                "id": 3,
                "rule": "optional"
              },
              "limit": {
                "type": "int32",
                "id": 4,
                "rule": "optional"
              }
            },
            "nested": {
              "Status": {
                "values": {
                  "UNKNOWN": 0,
                  "SUCCESS": 1,
                  "NOT_FOUND": 2,
                  "INVALID_REQUEST": 3
                }
              }
            }
          },
          "SendReferralRequest": {
            "fields": {
              "rewardCodeId": {
                "type": "int64",
                "id": 1,
                "rule": "optional"
              },
              "emailAddress": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "emailBody": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "SendReferralResponse": {
            "fields": {
              "status": {
                "type": "squareup.client.Status",
                "id": 1,
                "rule": "optional"
              },
              "idempotenceToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "sendReferralStatus": {
                "type": "squareup.rewards.SendReferralResponse.SendReferralStatus",
                "id": 3,
                "rule": "optional"
              }
            },
            "nested": {
              "SendReferralStatus": {
                "values": {
                  "UNKNOWN": 0,
                  "SUCCESS": 1,
                  "DUPLICATE_REFERRAL": 2,
                  "EXISTING_MERCHANT": 3,
                  "MISSING_DATA": 4,
                  "REWARD_CODE_NOT_FOUND": 5,
                  "SETUP_INCOMPLETE": 6,
                  "FAILED": 7,
                  "SYSTEM_ERROR": 8
                }
              }
            }
          },
          "GetRewardCodeReceiversRequest": {
            "fields": {
              "rewardCodeId": {
                "type": "int64",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "GetRewardCodeReceiversResponse": {
            "fields": {
              "status": {
                "type": "squareup.client.Status",
                "id": 1,
                "rule": "optional"
              },
              "receivers": {
                "type": "squareup.rewards.RewardCodeReceiver",
                "id": 2,
                "rule": "repeated"
              }
            }
          },
          "GetRedemptionCodesForMerchantRequest": {
            "fields": {
              "merchantToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "GetRedemptionCodeRequest": {
            "fields": {
              "token": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "RedeemRedemptionCodeRequest": {
            "fields": {
              "rewardCodeToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "RedeemRedemptionCodeInternalRequest": {
            "fields": {
              "rewardCodeToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "merchantToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "unitToken": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "GetRedemptionCodeResponse": {
            "fields": {
              "status": {
                "type": "squareup.rewards.GetRedemptionCodeResponse.Status",
                "id": 1,
                "rule": "optional"
              },
              "redemptionCode": {
                "type": "squareup.rewards.RedemptionCodeInternal",
                "id": 2,
                "rule": "optional"
              }
            },
            "nested": {
              "Status": {
                "values": {
                  "UNKNOWN": 0,
                  "SUCCESS": 1,
                  "NOT_FOUND": 2
                }
              }
            }
          },
          "GetRedemptionCodesForMerchantResponse": {
            "fields": {
              "status": {
                "type": "squareup.rewards.GetRedemptionCodesForMerchantResponse.Status",
                "id": 1,
                "rule": "optional"
              },
              "redemptionCodes": {
                "type": "squareup.rewards.RedemptionCodeInternal",
                "id": 2,
                "rule": "repeated"
              }
            },
            "nested": {
              "Status": {
                "values": {
                  "UNKNOWN": 0,
                  "SUCCESS": 1,
                  "NOT_FOUND": 2
                }
              }
            }
          },
          "RedeemRedemptionCodeResponse": {
            "fields": {
              "status": {
                "type": "squareup.rewards.RedeemRedemptionCodeResponse.Status",
                "id": 1,
                "rule": "optional"
              },
              "rewardName": {
                "type": "squareup.rewards.RewardName",
                "id": 2,
                "rule": "optional"
              }
            },
            "nested": {
              "Status": {
                "values": {
                  "UNKNOWN": 0,
                  "SUCCESS": 1,
                  "NOT_FOUND": 2,
                  "DUPLICATE_MERCHANT_REDEMPTION": 3,
                  "DUPLICATE_CODE_REDEMPTION": 4,
                  "MISMATCHED_CURRENCY_CODE": 5
                }
              }
            }
          },
          "GetReferralStatusesRequest": {
            "fields": {}
          },
          "GetReferralStatusesResponse": {
            "fields": {
              "referrals": {
                "type": "squareup.rewards.GetReferralStatusesResponse.Referral",
                "id": 1,
                "rule": "repeated"
              }
            },
            "nested": {
              "ReferralStatus": {
                "values": {
                  "UNKNOWN": 0,
                  "ERROR": 1,
                  "REQUIRES_SIGN_UP": 2,
                  "REQUIRES_SIGN_UP_NUDGEABLE": 3,
                  "REQUIRES_SIGN_UP_NUDGED": 4,
                  "REQUIRES_FIRST_CARD_PAYMENT": 5,
                  "REDEEMABLE": 6,
                  "REDEEMED": 7
                }
              },
              "Referral": {
                "fields": {
                  "emailAddressToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "refereeEmailAddress": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "rewardCodeUseId": {
                    "type": "int64",
                    "id": 3,
                    "rule": "optional"
                  },
                  "status": {
                    "type": "squareup.rewards.GetReferralStatusesResponse.ReferralStatus",
                    "id": 4,
                    "rule": "optional"
                  },
                  "statusUpdatedAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 5,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              }
            }
          },
          "NudgeReferralRequest": {
            "fields": {
              "emailAddressToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "GetPastMerchantBalancesRequest": {
            "fields": {
              "redeemedWithinDays": {
                "type": "int32",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "GetPastMerchantBalancesResponse": {
            "fields": {
              "status": {
                "type": "squareup.rewards.GetPastMerchantBalancesResponse.Status",
                "id": 1,
                "rule": "optional"
              },
              "balances": {
                "type": "squareup.rewards.Balance",
                "id": 2,
                "rule": "repeated"
              }
            },
            "nested": {
              "Status": {
                "values": {
                  "UNKNOWN": 0,
                  "SUCCESS": 1,
                  "NOT_FOUND": 2,
                  "INVALID_REQUEST": 3
                }
              }
            }
          },
          "ExpireMerchantBalanceRequest": {
            "fields": {
              "merchantToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "rewardName": {
                "type": "squareup.rewards.RewardName",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "ExpireMerchantBalanceResponse": {
            "fields": {
              "status": {
                "type": "squareup.rewards.ExpireMerchantBalanceResponse.Status",
                "id": 1,
                "rule": "optional"
              },
              "balance": {
                "type": "squareup.rewards.Balance",
                "id": 2,
                "rule": "optional"
              }
            },
            "nested": {
              "Status": {
                "values": {
                  "UNKNOWN": 0,
                  "SUCCESS": 1,
                  "NOT_FOUND": 2,
                  "INVALID_REQUEST": 3
                }
              }
            }
          },
          "RewardsService": {
            "methods": {
              "GetMerchantBalance": {
                "requestType": "squareup.rewards.GetMerchantBalanceRequest",
                "responseType": "squareup.rewards.GetMerchantBalanceResponse"
              },
              "ExternalGetMerchantBalance": {
                "requestType": "squareup.rewards.GetMerchantBalanceRequest",
                "responseType": "squareup.rewards.GetMerchantBalanceResponse"
              },
              "GetMerchantBalances": {
                "requestType": "squareup.rewards.GetMerchantBalancesRequest",
                "responseType": "squareup.rewards.GetMerchantBalancesResponse"
              },
              "GrantMerchantBalance": {
                "requestType": "squareup.rewards.GrantMerchantBalanceRequest",
                "responseType": "squareup.rewards.GrantMerchantBalanceResponse"
              },
              "BatchMigrateFromWeb": {
                "requestType": "squareup.rewards.MigrateFromWebBatchRequest",
                "responseType": "squareup.rewards.MigrateFromWebBatchResponse"
              },
              "GetFreeProcessingBalance": {
                "requestType": "squareup.rewards.GetFreeProcessingBalanceRequest",
                "responseType": "squareup.rewards.GetFreeProcessingBalanceResponse"
              },
              "GetFreeProcessingAdjustments": {
                "requestType": "squareup.rewards.GetFreeProcessingAdjustmentsRequest",
                "responseType": "squareup.rewards.GetFreeProcessingAdjustmentsResponse"
              },
              "GetFreeProcessingIncreases": {
                "requestType": "squareup.rewards.GetFreeProcessingIncreasesRequest",
                "responseType": "squareup.rewards.GetFreeProcessingIncreasesResponse"
              },
              "GetActiveBalances": {
                "requestType": "squareup.rewards.GetActiveBalancesRequest",
                "responseType": "squareup.rewards.GetActiveBalancesResponse"
              },
              "GetActiveBalancesV2": {
                "requestType": "squareup.rewards.GetActiveBalancesV2Request",
                "responseType": "squareup.rewards.GetActiveBalancesV2Response"
              },
              "GetYourRewards": {
                "requestType": "squareup.rewards.GetYourRewardsRequest",
                "responseType": "squareup.rewards.GetYourRewardsResponse"
              },
              "GetCurrentOffers": {
                "requestType": "squareup.rewards.GetCurrentOffersRequest",
                "responseType": "squareup.rewards.GetCurrentOffersResponse"
              },
              "GetRedeemableOffers": {
                "requestType": "squareup.rewards.GetRedeemableOffersRequest",
                "responseType": "squareup.rewards.GetRedeemableOffersResponse"
              },
              "RedeemReward": {
                "requestType": "squareup.rewards.RedeemRewardRequest",
                "responseType": "squareup.rewards.RedeemRewardResponse"
              },
              "DecrementMerchantBalance": {
                "requestType": "squareup.rewards.DecrementBalanceRequest",
                "responseType": "squareup.rewards.DecrementBalanceResponse"
              },
              "IncrementMerchantBalance": {
                "requestType": "squareup.rewards.IncrementBalanceRequest",
                "responseType": "squareup.rewards.IncrementBalanceResponse"
              },
              "LookupBalances": {
                "requestType": "squareup.rewards.LookupBalancesRequest",
                "responseType": "squareup.rewards.LookupBalancesResponse"
              },
              "LookupBalanceChanges": {
                "requestType": "squareup.rewards.LookupBalanceChangesRequest",
                "responseType": "squareup.rewards.LookupBalanceChangesResponse"
              },
              "LookupFreeProcessingAdjustments": {
                "requestType": "squareup.rewards.LookupFreeProcessingAdjustmentsRequest",
                "responseType": "squareup.rewards.LookupFreeProcessingAdjustmentsResponse"
              },
              "GetGrantedBalanceDetails": {
                "requestType": "squareup.rewards.GetGrantedBalanceDetailsRequest",
                "responseType": "squareup.rewards.GetGrantedBalanceDetailsResponse"
              },
              "GetFinanceProducts": {
                "requestType": "squareup.rewards.GetFinanceProductsRequest",
                "responseType": "squareup.rewards.GetFinanceProductsResponse"
              },
              "GetFinanceCampaignDetails": {
                "requestType": "squareup.rewards.GetFinanceCampaignDetailsRequest",
                "responseType": "squareup.rewards.GetFinanceCampaignDetailsResponse"
              },
              "SendReferral": {
                "requestType": "squareup.rewards.SendReferralRequest",
                "responseType": "squareup.rewards.SendReferralResponse"
              },
              "GetRewardCodeReceivers": {
                "requestType": "squareup.rewards.GetRewardCodeReceiversRequest",
                "responseType": "squareup.rewards.GetRewardCodeReceiversResponse"
              },
              "RedeemRedemptionCodeInternal": {
                "requestType": "squareup.rewards.RedeemRedemptionCodeInternalRequest",
                "responseType": "squareup.rewards.RedeemRedemptionCodeResponse"
              },
              "GetRedemptionCode": {
                "requestType": "squareup.rewards.GetRedemptionCodeRequest",
                "responseType": "squareup.rewards.GetRedemptionCodeResponse"
              },
              "GetRedemptionCodesForMerchant": {
                "requestType": "squareup.rewards.GetRedemptionCodesForMerchantRequest",
                "responseType": "squareup.rewards.GetRedemptionCodesForMerchantResponse"
              },
              "RedeemRedemptionCode": {
                "requestType": "squareup.rewards.RedeemRedemptionCodeRequest",
                "responseType": "squareup.rewards.RedeemRedemptionCodeResponse"
              },
              "GetReferralStatuses": {
                "requestType": "squareup.rewards.GetReferralStatusesRequest",
                "responseType": "squareup.rewards.GetReferralStatusesResponse"
              },
              "NudgeReferral": {
                "requestType": "squareup.rewards.NudgeReferralRequest",
                "responseType": "squareup.rewards.StatusResponse"
              },
              "GetPastMerchantBalances": {
                "requestType": "squareup.rewards.GetPastMerchantBalancesRequest",
                "responseType": "squareup.rewards.GetPastMerchantBalancesResponse"
              },
              "RedeemSpecificReward": {
                "requestType": "squareup.rewards.RedeemRewardRequest",
                "responseType": "squareup.rewards.RedeemRewardResponse"
              },
              "WebhookIterable": {
                "requestType": "squareup.rewards.WebhookIterableRequest",
                "responseType": "google.protobuf.Empty"
              },
              "WebhookCreateCampaignEnrollment": {
                "requestType": "squareup.rewards.WebhookCreateCampaignEnrollmentRequest",
                "responseType": "google.protobuf.Empty"
              },
              "WebhookUpdateCampaignEnrollment": {
                "requestType": "squareup.rewards.WebhookUpdateCampaignEnrollmentRequest",
                "responseType": "google.protobuf.Empty"
              },
              "WebhookCreateMilestone": {
                "requestType": "squareup.rewards.WebhookCreateMilestoneRequest",
                "responseType": "google.protobuf.Empty"
              },
              "GetReferrerCurrentSignupToken": {
                "requestType": "squareup.client.onboard.ReferrerCurrentSignupTokenRequest",
                "responseType": "squareup.client.onboard.ReferrerCurrentSignupTokenResponse"
              },
              "ExpireMerchantBalance": {
                "requestType": "squareup.rewards.ExpireMerchantBalanceRequest",
                "responseType": "squareup.rewards.ExpireMerchantBalanceResponse"
              }
            }
          }
        }
      }
    }
  }
});

/**
 * SOURCE GetMerchantBalanceRequest @ squareup/rewards/service.proto at 272:1
 */
export const GetMerchantBalanceRequest = $root.lookupType('squareup.rewards.GetMerchantBalanceRequest');
fixType(GetMerchantBalanceRequest);
Builder.createAndAttachToType(GetMerchantBalanceRequest);
/**
 * SOURCE GetMerchantBalanceResponse @ squareup/rewards/service.proto at 285:1
 */
export const GetMerchantBalanceResponse = $root.lookupType('squareup.rewards.GetMerchantBalanceResponse');
fixType(GetMerchantBalanceResponse, {
  status: { required: true },
});
Builder.createAndAttachToType(GetMerchantBalanceResponse);
/**
 * SOURCE Status @ squareup/rewards/service.proto at 286:3
 */
GetMerchantBalanceResponse.Status = $root.lookupEnum('squareup.rewards.GetMerchantBalanceResponse.Status').values;
/**
 * This is defined to conform to RpcController protocol
 *
 * SOURCE GetMerchantBalancesRequest @ squareup/rewards/service.proto at 298:1
 */
export const GetMerchantBalancesRequest = $root.lookupType('squareup.rewards.GetMerchantBalancesRequest');
fixType(GetMerchantBalancesRequest);
Builder.createAndAttachToType(GetMerchantBalancesRequest);
/**
 * SOURCE GetMerchantBalancesResponse @ squareup/rewards/service.proto at 311:1
 */
export const GetMerchantBalancesResponse = $root.lookupType('squareup.rewards.GetMerchantBalancesResponse');
fixType(GetMerchantBalancesResponse, {
  status: { required: true },
});
Builder.createAndAttachToType(GetMerchantBalancesResponse);
/**
 * SOURCE Status @ squareup/rewards/service.proto at 312:3
 */
GetMerchantBalancesResponse.Status = $root.lookupEnum('squareup.rewards.GetMerchantBalancesResponse.Status').values;
/**
 * SOURCE GrantMerchantBalanceRequest @ squareup/rewards/service.proto at 323:1
 */
export const GrantMerchantBalanceRequest = $root.lookupType('squareup.rewards.GrantMerchantBalanceRequest');
fixType(GrantMerchantBalanceRequest);
Builder.createAndAttachToType(GrantMerchantBalanceRequest);
/**
 * SOURCE GrantMerchantBalanceResponse @ squareup/rewards/service.proto at 373:1
 */
export const GrantMerchantBalanceResponse = $root.lookupType('squareup.rewards.GrantMerchantBalanceResponse');
fixType(GrantMerchantBalanceResponse, {
  status: { required: true },
});
Builder.createAndAttachToType(GrantMerchantBalanceResponse);
/**
 * SOURCE Status @ squareup/rewards/service.proto at 374:3
 */
GrantMerchantBalanceResponse.Status = $root.lookupEnum('squareup.rewards.GrantMerchantBalanceResponse.Status').values;
/**
 * No longer in use as the web migration is complete.
 *
 * SOURCE WebFreeProcessingBalance @ squareup/rewards/service.proto at 387:1
 */
export const WebFreeProcessingBalance = $root.lookupType('squareup.rewards.WebFreeProcessingBalance');
fixType(WebFreeProcessingBalance);
Builder.createAndAttachToType(WebFreeProcessingBalance);
/**
 * No longer in use as the web migration is complete.
 *
 * SOURCE MigrateFromWebBatchRequest @ squareup/rewards/service.proto at 395:1
 */
export const MigrateFromWebBatchRequest = $root.lookupType('squareup.rewards.MigrateFromWebBatchRequest');
fixType(MigrateFromWebBatchRequest);
Builder.createAndAttachToType(MigrateFromWebBatchRequest);
/**
 * No longer in use as the web migration is complete.
 *
 * SOURCE MigrateFromWebBatchResponse @ squareup/rewards/service.proto at 401:1
 */
export const MigrateFromWebBatchResponse = $root.lookupType('squareup.rewards.MigrateFromWebBatchResponse');
fixType(MigrateFromWebBatchResponse);
Builder.createAndAttachToType(MigrateFromWebBatchResponse);
/**
 * SOURCE Status @ squareup/rewards/service.proto at 404:3
 */
MigrateFromWebBatchResponse.Status = $root.lookupEnum('squareup.rewards.MigrateFromWebBatchResponse.Status').values;
/**
 * Regulator endpoint to get free processing balances for a particular user.
 *
 * SOURCE GetFreeProcessingBalanceRequest @ squareup/rewards/service.proto at 415:1
 */
export const GetFreeProcessingBalanceRequest = $root.lookupType('squareup.rewards.GetFreeProcessingBalanceRequest');
fixType(GetFreeProcessingBalanceRequest);
Builder.createAndAttachToType(GetFreeProcessingBalanceRequest);
/**
 * SOURCE GetFreeProcessingBalanceResponse @ squareup/rewards/service.proto at 422:1
 */
export const GetFreeProcessingBalanceResponse = $root.lookupType('squareup.rewards.GetFreeProcessingBalanceResponse');
fixType(GetFreeProcessingBalanceResponse);
Builder.createAndAttachToType(GetFreeProcessingBalanceResponse);
/**
 * Custom balance proto for Regulator
 *
 * SOURCE FreeProcessingBalance @ squareup/rewards/service.proto at 424:3
 */
GetFreeProcessingBalanceResponse.FreeProcessingBalance = $root.lookupType('squareup.rewards.GetFreeProcessingBalanceResponse.FreeProcessingBalance');
fixType(GetFreeProcessingBalanceResponse.FreeProcessingBalance);
Builder.createAndAttachToType(GetFreeProcessingBalanceResponse.FreeProcessingBalance);
/**
 * SOURCE GetFreeProcessingAdjustmentsRequest @ squareup/rewards/service.proto at 438:1
 */
export const GetFreeProcessingAdjustmentsRequest = $root.lookupType('squareup.rewards.GetFreeProcessingAdjustmentsRequest');
fixType(GetFreeProcessingAdjustmentsRequest);
Builder.createAndAttachToType(GetFreeProcessingAdjustmentsRequest);
/**
 * SOURCE GetFreeProcessingAdjustmentsResponse @ squareup/rewards/service.proto at 448:1
 */
export const GetFreeProcessingAdjustmentsResponse = $root.lookupType('squareup.rewards.GetFreeProcessingAdjustmentsResponse');
fixType(GetFreeProcessingAdjustmentsResponse);
Builder.createAndAttachToType(GetFreeProcessingAdjustmentsResponse);
/**
 * Custom adjustment proto for Regulator
 *
 * SOURCE FreeProcessingAdjustment @ squareup/rewards/service.proto at 450:3
 */
GetFreeProcessingAdjustmentsResponse.FreeProcessingAdjustment = $root.lookupType('squareup.rewards.GetFreeProcessingAdjustmentsResponse.FreeProcessingAdjustment');
fixType(GetFreeProcessingAdjustmentsResponse.FreeProcessingAdjustment);
Builder.createAndAttachToType(GetFreeProcessingAdjustmentsResponse.FreeProcessingAdjustment);
/**
 * SOURCE GetFreeProcessingIncreasesRequest @ squareup/rewards/service.proto at 460:1
 */
export const GetFreeProcessingIncreasesRequest = $root.lookupType('squareup.rewards.GetFreeProcessingIncreasesRequest');
fixType(GetFreeProcessingIncreasesRequest);
Builder.createAndAttachToType(GetFreeProcessingIncreasesRequest);
/**
 * SOURCE Scope @ squareup/rewards/service.proto at 461:3
 */
GetFreeProcessingIncreasesRequest.Scope = $root.lookupEnum('squareup.rewards.GetFreeProcessingIncreasesRequest.Scope').values;
/**
 * SOURCE GetFreeProcessingIncreasesResponse @ squareup/rewards/service.proto at 477:1
 */
export const GetFreeProcessingIncreasesResponse = $root.lookupType('squareup.rewards.GetFreeProcessingIncreasesResponse');
fixType(GetFreeProcessingIncreasesResponse);
Builder.createAndAttachToType(GetFreeProcessingIncreasesResponse);
/**
 * Custom increase proto for Regulator
 *
 * SOURCE FreeProcessingIncrease @ squareup/rewards/service.proto at 479:3
 */
GetFreeProcessingIncreasesResponse.FreeProcessingIncrease = $root.lookupType('squareup.rewards.GetFreeProcessingIncreasesResponse.FreeProcessingIncrease');
fixType(GetFreeProcessingIncreasesResponse.FreeProcessingIncrease);
Builder.createAndAttachToType(GetFreeProcessingIncreasesResponse.FreeProcessingIncrease);
/**
 * SOURCE GetActiveBalancesRequest @ squareup/rewards/service.proto at 490:1
 */
export const GetActiveBalancesRequest = $root.lookupType('squareup.rewards.GetActiveBalancesRequest');
fixType(GetActiveBalancesRequest);
Builder.createAndAttachToType(GetActiveBalancesRequest);
/**
 * SOURCE GetActiveBalancesResponse @ squareup/rewards/service.proto at 492:1
 */
export const GetActiveBalancesResponse = $root.lookupType('squareup.rewards.GetActiveBalancesResponse');
fixType(GetActiveBalancesResponse);
Builder.createAndAttachToType(GetActiveBalancesResponse);
/**
 * SOURCE GetActiveBalancesV2Request @ squareup/rewards/service.proto at 496:1
 */
export const GetActiveBalancesV2Request = $root.lookupType('squareup.rewards.GetActiveBalancesV2Request');
fixType(GetActiveBalancesV2Request);
Builder.createAndAttachToType(GetActiveBalancesV2Request);
/**
 * SOURCE GetActiveBalancesV2Response @ squareup/rewards/service.proto at 501:1
 */
export const GetActiveBalancesV2Response = $root.lookupType('squareup.rewards.GetActiveBalancesV2Response');
fixType(GetActiveBalancesV2Response);
Builder.createAndAttachToType(GetActiveBalancesV2Response);
/**
 * SOURCE BalancesOfReward @ squareup/rewards/service.proto at 502:3
 */
GetActiveBalancesV2Response.BalancesOfReward = $root.lookupType('squareup.rewards.GetActiveBalancesV2Response.BalancesOfReward');
fixType(GetActiveBalancesV2Response.BalancesOfReward);
Builder.createAndAttachToType(GetActiveBalancesV2Response.BalancesOfReward);
/**
 * SOURCE GetYourRewardsRequest @ squareup/rewards/service.proto at 515:1
 */
export const GetYourRewardsRequest = $root.lookupType('squareup.rewards.GetYourRewardsRequest');
fixType(GetYourRewardsRequest);
Builder.createAndAttachToType(GetYourRewardsRequest);
/**
 * SOURCE GetYourRewardsResponse @ squareup/rewards/service.proto at 520:1
 */
export const GetYourRewardsResponse = $root.lookupType('squareup.rewards.GetYourRewardsResponse');
fixType(GetYourRewardsResponse);
Builder.createAndAttachToType(GetYourRewardsResponse);
/**
 * SOURCE RedeemableReward @ squareup/rewards/service.proto at 521:3
 */
GetYourRewardsResponse.RedeemableReward = $root.lookupType('squareup.rewards.GetYourRewardsResponse.RedeemableReward');
fixType(GetYourRewardsResponse.RedeemableReward);
Builder.createAndAttachToType(GetYourRewardsResponse.RedeemableReward);
/**
 * SOURCE GetCurrentOffersRequest @ squareup/rewards/service.proto at 535:1
 */
export const GetCurrentOffersRequest = $root.lookupType('squareup.rewards.GetCurrentOffersRequest');
fixType(GetCurrentOffersRequest);
Builder.createAndAttachToType(GetCurrentOffersRequest);
/**
 * SOURCE GetCurrentOffersResponse @ squareup/rewards/service.proto at 541:1
 */
export const GetCurrentOffersResponse = $root.lookupType('squareup.rewards.GetCurrentOffersResponse');
fixType(GetCurrentOffersResponse);
Builder.createAndAttachToType(GetCurrentOffersResponse);
/**
 * SOURCE SelectableOffer @ squareup/rewards/service.proto at 542:3
 */
GetCurrentOffersResponse.SelectableOffer = $root.lookupType('squareup.rewards.GetCurrentOffersResponse.SelectableOffer');
fixType(GetCurrentOffersResponse.SelectableOffer);
Builder.createAndAttachToType(GetCurrentOffersResponse.SelectableOffer);
/**
 * SOURCE GetRedeemableOffersRequest @ squareup/rewards/service.proto at 556:1
 */
export const GetRedeemableOffersRequest = $root.lookupType('squareup.rewards.GetRedeemableOffersRequest');
fixType(GetRedeemableOffersRequest);
Builder.createAndAttachToType(GetRedeemableOffersRequest);
/**
 * SOURCE GetRedeemableOffersResponse @ squareup/rewards/service.proto at 562:1
 */
export const GetRedeemableOffersResponse = $root.lookupType('squareup.rewards.GetRedeemableOffersResponse');
fixType(GetRedeemableOffersResponse);
Builder.createAndAttachToType(GetRedeemableOffersResponse);
/**
 * SOURCE RedeemRewardRequest @ squareup/rewards/service.proto at 569:1
 */
export const RedeemRewardRequest = $root.lookupType('squareup.rewards.RedeemRewardRequest');
fixType(RedeemRewardRequest);
Builder.createAndAttachToType(RedeemRewardRequest);
/**
 * SOURCE RedeemRewardResponse @ squareup/rewards/service.proto at 575:1
 */
export const RedeemRewardResponse = $root.lookupType('squareup.rewards.RedeemRewardResponse');
fixType(RedeemRewardResponse);
Builder.createAndAttachToType(RedeemRewardResponse);
/**
 * SOURCE Status @ squareup/rewards/service.proto at 576:3
 */
RedeemRewardResponse.Status = $root.lookupEnum('squareup.rewards.RedeemRewardResponse.Status').values;
/**
 * SOURCE RedeemedReward @ squareup/rewards/service.proto at 582:3
 */
RedeemRewardResponse.RedeemedReward = $root.lookupType('squareup.rewards.RedeemRewardResponse.RedeemedReward');
fixType(RedeemRewardResponse.RedeemedReward);
Builder.createAndAttachToType(RedeemRewardResponse.RedeemedReward);
/**
 * SOURCE WebhookIterableRequest @ squareup/rewards/service.proto at 598:1
 */
export const WebhookIterableRequest = $root.lookupType('squareup.rewards.WebhookIterableRequest');
fixType(WebhookIterableRequest);
Builder.createAndAttachToType(WebhookIterableRequest);
/**
 * SOURCE WebhookCreateCampaignEnrollmentRequest @ squareup/rewards/service.proto at 602:1
 */
export const WebhookCreateCampaignEnrollmentRequest = $root.lookupType('squareup.rewards.WebhookCreateCampaignEnrollmentRequest');
fixType(WebhookCreateCampaignEnrollmentRequest);
Builder.createAndAttachToType(WebhookCreateCampaignEnrollmentRequest);
/**
 * SOURCE WebhookUpdateCampaignEnrollmentRequest @ squareup/rewards/service.proto at 607:1
 */
export const WebhookUpdateCampaignEnrollmentRequest = $root.lookupType('squareup.rewards.WebhookUpdateCampaignEnrollmentRequest');
fixType(WebhookUpdateCampaignEnrollmentRequest);
Builder.createAndAttachToType(WebhookUpdateCampaignEnrollmentRequest);
/**
 * SOURCE WebhookCreateMilestoneRequest @ squareup/rewards/service.proto at 612:1
 */
export const WebhookCreateMilestoneRequest = $root.lookupType('squareup.rewards.WebhookCreateMilestoneRequest');
fixType(WebhookCreateMilestoneRequest);
Builder.createAndAttachToType(WebhookCreateMilestoneRequest);
/**
 * SOURCE DecrementBalanceRequest @ squareup/rewards/service.proto at 617:1
 */
export const DecrementBalanceRequest = $root.lookupType('squareup.rewards.DecrementBalanceRequest');
fixType(DecrementBalanceRequest);
Builder.createAndAttachToType(DecrementBalanceRequest);
/**
 * SOURCE DecrementBalanceResponse @ squareup/rewards/service.proto at 631:1
 */
export const DecrementBalanceResponse = $root.lookupType('squareup.rewards.DecrementBalanceResponse');
fixType(DecrementBalanceResponse);
Builder.createAndAttachToType(DecrementBalanceResponse);
/**
 * SOURCE Status @ squareup/rewards/service.proto at 632:3
 */
DecrementBalanceResponse.Status = $root.lookupEnum('squareup.rewards.DecrementBalanceResponse.Status').values;
/**
 * SOURCE IncrementBalanceRequest @ squareup/rewards/service.proto at 642:1
 */
export const IncrementBalanceRequest = $root.lookupType('squareup.rewards.IncrementBalanceRequest');
fixType(IncrementBalanceRequest);
Builder.createAndAttachToType(IncrementBalanceRequest);
/**
 * SOURCE IncrementBalanceResponse @ squareup/rewards/service.proto at 652:1
 */
export const IncrementBalanceResponse = $root.lookupType('squareup.rewards.IncrementBalanceResponse');
fixType(IncrementBalanceResponse);
Builder.createAndAttachToType(IncrementBalanceResponse);
/**
 * SOURCE Status @ squareup/rewards/service.proto at 653:3
 */
IncrementBalanceResponse.Status = $root.lookupEnum('squareup.rewards.IncrementBalanceResponse.Status').values;
/**
 * SOURCE LookupBalancesRequest @ squareup/rewards/service.proto at 664:1
 */
export const LookupBalancesRequest = $root.lookupType('squareup.rewards.LookupBalancesRequest');
fixType(LookupBalancesRequest);
Builder.createAndAttachToType(LookupBalancesRequest);
/**
 * SOURCE LookupBalancesResponse @ squareup/rewards/service.proto at 671:1
 */
export const LookupBalancesResponse = $root.lookupType('squareup.rewards.LookupBalancesResponse');
fixType(LookupBalancesResponse);
Builder.createAndAttachToType(LookupBalancesResponse);
/**
 * SOURCE Status @ squareup/rewards/service.proto at 672:3
 */
LookupBalancesResponse.Status = $root.lookupEnum('squareup.rewards.LookupBalancesResponse.Status').values;
/**
 * SOURCE BalanceEntry @ squareup/rewards/service.proto at 679:3
 */
LookupBalancesResponse.BalanceEntry = $root.lookupType('squareup.rewards.LookupBalancesResponse.BalanceEntry');
fixType(LookupBalancesResponse.BalanceEntry);
Builder.createAndAttachToType(LookupBalancesResponse.BalanceEntry);
/**
 * SOURCE LookupFreeProcessingAdjustmentsRequest @ squareup/rewards/service.proto at 690:1
 */
export const LookupFreeProcessingAdjustmentsRequest = $root.lookupType('squareup.rewards.LookupFreeProcessingAdjustmentsRequest');
fixType(LookupFreeProcessingAdjustmentsRequest);
Builder.createAndAttachToType(LookupFreeProcessingAdjustmentsRequest);
/**
 * SOURCE LookupFreeProcessingAdjustmentsResponse @ squareup/rewards/service.proto at 697:1
 */
export const LookupFreeProcessingAdjustmentsResponse = $root.lookupType('squareup.rewards.LookupFreeProcessingAdjustmentsResponse');
fixType(LookupFreeProcessingAdjustmentsResponse);
Builder.createAndAttachToType(LookupFreeProcessingAdjustmentsResponse);
/**
 * SOURCE Status @ squareup/rewards/service.proto at 698:3
 */
LookupFreeProcessingAdjustmentsResponse.Status = $root.lookupEnum('squareup.rewards.LookupFreeProcessingAdjustmentsResponse.Status').values;
/**
 * SOURCE LookupBalanceChangesRequest @ squareup/rewards/service.proto at 710:1
 */
export const LookupBalanceChangesRequest = $root.lookupType('squareup.rewards.LookupBalanceChangesRequest');
fixType(LookupBalanceChangesRequest);
Builder.createAndAttachToType(LookupBalanceChangesRequest);
/**
 * SOURCE Scope @ squareup/rewards/service.proto at 711:3
 */
LookupBalanceChangesRequest.Scope = $root.lookupEnum('squareup.rewards.LookupBalanceChangesRequest.Scope').values;
/**
 * SOURCE LookupBalanceChangesResponse @ squareup/rewards/service.proto at 726:1
 */
export const LookupBalanceChangesResponse = $root.lookupType('squareup.rewards.LookupBalanceChangesResponse');
fixType(LookupBalanceChangesResponse);
Builder.createAndAttachToType(LookupBalanceChangesResponse);
/**
 * SOURCE Status @ squareup/rewards/service.proto at 727:3
 */
LookupBalanceChangesResponse.Status = $root.lookupEnum('squareup.rewards.LookupBalanceChangesResponse.Status').values;
/**
 * SOURCE GetGrantedBalanceDetailsRequest @ squareup/rewards/service.proto at 738:1
 */
export const GetGrantedBalanceDetailsRequest = $root.lookupType('squareup.rewards.GetGrantedBalanceDetailsRequest');
fixType(GetGrantedBalanceDetailsRequest);
Builder.createAndAttachToType(GetGrantedBalanceDetailsRequest);
/**
 * SOURCE GetGrantedBalanceDetailsResponse @ squareup/rewards/service.proto at 761:1
 */
export const GetGrantedBalanceDetailsResponse = $root.lookupType('squareup.rewards.GetGrantedBalanceDetailsResponse');
fixType(GetGrantedBalanceDetailsResponse, {
  status: { required: true },
});
Builder.createAndAttachToType(GetGrantedBalanceDetailsResponse);
/**
 * SOURCE Status @ squareup/rewards/service.proto at 762:3
 */
GetGrantedBalanceDetailsResponse.Status = $root.lookupEnum('squareup.rewards.GetGrantedBalanceDetailsResponse.Status').values;
/**
 * SOURCE GetFinanceProductsRequest @ squareup/rewards/service.proto at 776:1
 */
export const GetFinanceProductsRequest = $root.lookupType('squareup.rewards.GetFinanceProductsRequest');
fixType(GetFinanceProductsRequest);
Builder.createAndAttachToType(GetFinanceProductsRequest);
/**
 * SOURCE GetFinanceProductsResponse @ squareup/rewards/service.proto at 787:1
 */
export const GetFinanceProductsResponse = $root.lookupType('squareup.rewards.GetFinanceProductsResponse');
fixType(GetFinanceProductsResponse, {
  status: { required: true },
});
Builder.createAndAttachToType(GetFinanceProductsResponse);
/**
 * SOURCE Status @ squareup/rewards/service.proto at 788:3
 */
GetFinanceProductsResponse.Status = $root.lookupEnum('squareup.rewards.GetFinanceProductsResponse.Status').values;
/**
 * SOURCE GetFinanceCampaignDetailsRequest @ squareup/rewards/service.proto at 802:1
 */
export const GetFinanceCampaignDetailsRequest = $root.lookupType('squareup.rewards.GetFinanceCampaignDetailsRequest');
fixType(GetFinanceCampaignDetailsRequest);
Builder.createAndAttachToType(GetFinanceCampaignDetailsRequest);
/**
 * SOURCE GetFinanceCampaignDetailsResponse @ squareup/rewards/service.proto at 810:1
 */
export const GetFinanceCampaignDetailsResponse = $root.lookupType('squareup.rewards.GetFinanceCampaignDetailsResponse');
fixType(GetFinanceCampaignDetailsResponse, {
  status: { required: true },
});
Builder.createAndAttachToType(GetFinanceCampaignDetailsResponse);
/**
 * SOURCE Status @ squareup/rewards/service.proto at 811:3
 */
GetFinanceCampaignDetailsResponse.Status = $root.lookupEnum('squareup.rewards.GetFinanceCampaignDetailsResponse.Status').values;
/**
 * SOURCE SendReferralRequest @ squareup/rewards/service.proto at 825:1
 */
export const SendReferralRequest = $root.lookupType('squareup.rewards.SendReferralRequest');
fixType(SendReferralRequest);
Builder.createAndAttachToType(SendReferralRequest);
/**
 * SOURCE SendReferralResponse @ squareup/rewards/service.proto at 831:1
 */
export const SendReferralResponse = $root.lookupType('squareup.rewards.SendReferralResponse');
fixType(SendReferralResponse, {
  status: { required: true },
});
Builder.createAndAttachToType(SendReferralResponse);
/**
 * SOURCE SendReferralStatus @ squareup/rewards/service.proto at 832:3
 */
SendReferralResponse.SendReferralStatus = $root.lookupEnum('squareup.rewards.SendReferralResponse.SendReferralStatus').values;
/**
 * SOURCE GetRewardCodeReceiversRequest @ squareup/rewards/service.proto at 865:1
 */
export const GetRewardCodeReceiversRequest = $root.lookupType('squareup.rewards.GetRewardCodeReceiversRequest');
fixType(GetRewardCodeReceiversRequest);
Builder.createAndAttachToType(GetRewardCodeReceiversRequest);
/**
 * SOURCE GetRewardCodeReceiversResponse @ squareup/rewards/service.proto at 869:1
 */
export const GetRewardCodeReceiversResponse = $root.lookupType('squareup.rewards.GetRewardCodeReceiversResponse');
fixType(GetRewardCodeReceiversResponse, {
  status: { required: true },
});
Builder.createAndAttachToType(GetRewardCodeReceiversResponse);
/**
 * SOURCE GetRedemptionCodesForMerchantRequest @ squareup/rewards/service.proto at 874:1
 */
export const GetRedemptionCodesForMerchantRequest = $root.lookupType('squareup.rewards.GetRedemptionCodesForMerchantRequest');
fixType(GetRedemptionCodesForMerchantRequest);
Builder.createAndAttachToType(GetRedemptionCodesForMerchantRequest);
/**
 * SOURCE GetRedemptionCodeRequest @ squareup/rewards/service.proto at 878:1
 */
export const GetRedemptionCodeRequest = $root.lookupType('squareup.rewards.GetRedemptionCodeRequest');
fixType(GetRedemptionCodeRequest);
Builder.createAndAttachToType(GetRedemptionCodeRequest);
/**
 * SOURCE RedeemRedemptionCodeRequest @ squareup/rewards/service.proto at 882:1
 */
export const RedeemRedemptionCodeRequest = $root.lookupType('squareup.rewards.RedeemRedemptionCodeRequest');
fixType(RedeemRedemptionCodeRequest);
Builder.createAndAttachToType(RedeemRedemptionCodeRequest);
/**
 * SOURCE RedeemRedemptionCodeInternalRequest @ squareup/rewards/service.proto at 886:1
 */
export const RedeemRedemptionCodeInternalRequest = $root.lookupType('squareup.rewards.RedeemRedemptionCodeInternalRequest');
fixType(RedeemRedemptionCodeInternalRequest);
Builder.createAndAttachToType(RedeemRedemptionCodeInternalRequest);
/**
 * SOURCE GetRedemptionCodeResponse @ squareup/rewards/service.proto at 892:1
 */
export const GetRedemptionCodeResponse = $root.lookupType('squareup.rewards.GetRedemptionCodeResponse');
fixType(GetRedemptionCodeResponse, {
  status: { required: true },
});
Builder.createAndAttachToType(GetRedemptionCodeResponse);
/**
 * SOURCE Status @ squareup/rewards/service.proto at 893:3
 */
GetRedemptionCodeResponse.Status = $root.lookupEnum('squareup.rewards.GetRedemptionCodeResponse.Status').values;
/**
 * SOURCE GetRedemptionCodesForMerchantResponse @ squareup/rewards/service.proto at 903:1
 */
export const GetRedemptionCodesForMerchantResponse = $root.lookupType('squareup.rewards.GetRedemptionCodesForMerchantResponse');
fixType(GetRedemptionCodesForMerchantResponse, {
  status: { required: true },
});
Builder.createAndAttachToType(GetRedemptionCodesForMerchantResponse);
/**
 * SOURCE Status @ squareup/rewards/service.proto at 904:3
 */
GetRedemptionCodesForMerchantResponse.Status = $root.lookupEnum('squareup.rewards.GetRedemptionCodesForMerchantResponse.Status').values;
/**
 * SOURCE RedeemRedemptionCodeResponse @ squareup/rewards/service.proto at 914:1
 */
export const RedeemRedemptionCodeResponse = $root.lookupType('squareup.rewards.RedeemRedemptionCodeResponse');
fixType(RedeemRedemptionCodeResponse, {
  status: { required: true },
});
Builder.createAndAttachToType(RedeemRedemptionCodeResponse);
/**
 * SOURCE Status @ squareup/rewards/service.proto at 915:3
 */
RedeemRedemptionCodeResponse.Status = $root.lookupEnum('squareup.rewards.RedeemRedemptionCodeResponse.Status').values;
/**
 * SOURCE GetReferralStatusesRequest @ squareup/rewards/service.proto at 930:1
 */
export const GetReferralStatusesRequest = $root.lookupType('squareup.rewards.GetReferralStatusesRequest');
fixType(GetReferralStatusesRequest);
Builder.createAndAttachToType(GetReferralStatusesRequest);
/**
 * SOURCE GetReferralStatusesResponse @ squareup/rewards/service.proto at 932:1
 */
export const GetReferralStatusesResponse = $root.lookupType('squareup.rewards.GetReferralStatusesResponse');
fixType(GetReferralStatusesResponse);
Builder.createAndAttachToType(GetReferralStatusesResponse);
/**
 * SOURCE ReferralStatus @ squareup/rewards/service.proto at 933:3
 */
GetReferralStatusesResponse.ReferralStatus = $root.lookupEnum('squareup.rewards.GetReferralStatusesResponse.ReferralStatus').values;
/**
 * SOURCE Referral @ squareup/rewards/service.proto at 956:3
 */
GetReferralStatusesResponse.Referral = $root.lookupType('squareup.rewards.GetReferralStatusesResponse.Referral');
fixType(GetReferralStatusesResponse.Referral);
Builder.createAndAttachToType(GetReferralStatusesResponse.Referral);
/**
 * SOURCE NudgeReferralRequest @ squareup/rewards/service.proto at 981:1
 */
export const NudgeReferralRequest = $root.lookupType('squareup.rewards.NudgeReferralRequest');
fixType(NudgeReferralRequest);
Builder.createAndAttachToType(NudgeReferralRequest);
/**
 * SOURCE GetPastMerchantBalancesRequest @ squareup/rewards/service.proto at 986:1
 */
export const GetPastMerchantBalancesRequest = $root.lookupType('squareup.rewards.GetPastMerchantBalancesRequest');
fixType(GetPastMerchantBalancesRequest);
Builder.createAndAttachToType(GetPastMerchantBalancesRequest);
/**
 * SOURCE GetPastMerchantBalancesResponse @ squareup/rewards/service.proto at 991:1
 */
export const GetPastMerchantBalancesResponse = $root.lookupType('squareup.rewards.GetPastMerchantBalancesResponse');
fixType(GetPastMerchantBalancesResponse, {
  status: { required: true },
});
Builder.createAndAttachToType(GetPastMerchantBalancesResponse);
/**
 * SOURCE Status @ squareup/rewards/service.proto at 992:3
 */
GetPastMerchantBalancesResponse.Status = $root.lookupEnum('squareup.rewards.GetPastMerchantBalancesResponse.Status').values;
/**
 * SOURCE ExpireMerchantBalanceRequest @ squareup/rewards/service.proto at 1003:1
 */
export const ExpireMerchantBalanceRequest = $root.lookupType('squareup.rewards.ExpireMerchantBalanceRequest');
fixType(ExpireMerchantBalanceRequest);
Builder.createAndAttachToType(ExpireMerchantBalanceRequest);
/**
 * SOURCE ExpireMerchantBalanceResponse @ squareup/rewards/service.proto at 1008:1
 */
export const ExpireMerchantBalanceResponse = $root.lookupType('squareup.rewards.ExpireMerchantBalanceResponse');
fixType(ExpireMerchantBalanceResponse, {
  status: { required: true },
});
Builder.createAndAttachToType(ExpireMerchantBalanceResponse);
/**
 * SOURCE Status @ squareup/rewards/service.proto at 1009:3
 */
ExpireMerchantBalanceResponse.Status = $root.lookupEnum('squareup.rewards.ExpireMerchantBalanceResponse.Status').values;
/**
 * SOURCE RewardsService @ squareup/rewards/service.proto at 18:1
 */
export const RewardsService = $root.lookupService('squareup.rewards.RewardsService');
